/** @jsx jsx */
import { jsx } from '@emotion/core'
import _ from 'lodash'
import {
  authStore, bettingHistoryStore,
  chattingStore,
  componentStore,
  globalStore, matchupStore,
  reportStore,
  userStore,
} from '@store/index'
import { UploadImgStyle } from '@views/Popup/Chat/index.style'
import { UserPickNullOngoingBetInfo } from '@views/Home/UserPick/Components/UserPickNullOngoingBetInfo'
import { UserPickIsOngoingBetInfo } from '@views/Home/UserPick/Components/UserPickIsOngoingBetInfo'
import { EtcMarketFilterList } from '@views/Home/UserPick/UserPickContents/EtcMarketFilterList'
import { Schema$UserPickMarket } from '@interface/user-pick'
import { RatingInfo } from '@views/MyPage/UserActivity/RatingInfo'
import { Schema$UserActivitySummary } from '@interface/user-activity'
import { MatchRecord, MatchRecordSimpleMatchInfo } from '@views/MatchRecord'
import * as Utils from '@utils/utils'
import { loadOrReload, showToast, TOAST_TYPE } from '@utils/utils'
import { AdvReportList } from '@components/AdvReport'
import { COMMUNICATION_BLOCK_TYPE, FROM_VIEW_TYPE, GlobalStoreKey, USER_REPORT_TYPE } from '@v2/constants/common'
import { AdvBlockList } from '@components/AdvBlock'
import { ERR } from 'adv-protocol/src/ErrorCodes'
import { UserPenaltyInfo } from '@components/AdvPenalty/UserPenaltyInfo'
import { UserTitleSetting } from '@components/UserTitle/userTitleSetting'
import { UnableToJoinInfo } from '@views/Login/KakaoLogin/UnableToJoinInfo'
import { TransferApplicationCompletedInfo } from '@views/Login/KakaoLogin/TransferApplicationCompletedInfo'
import { ApplyForAccountTransferInfo } from '@views/Login/KakaoLogin/ApplyForAccountTransferInfo'
import { KakaoServiceTerminationInfo } from '@views/Login/KakaoLogin/KakaoServiceTerminationInfo'
import { ApplyForNewAccount } from '@views/Login/KakaoLogin/ApplyForNewAccount'
import { TransferableAccount } from '@store/userStore'
import { ACCOUNT_TYPE, LogoutType } from '@interface/common'
import StorageUtils from '@utils/storage-utils'
import { SoccerCardCountGuide } from '@views/Home/UserPick/Components/SoccerCardCountGuide'
import { ChatPenaltyInfo } from '@components/AdvPenalty/ChatPenaltyInfo'
import SharedBettingListPopup from '@views/Popup/Chat/SharedBettingListPopup'
import { Fragment } from 'react'
import { isMobile } from 'react-device-detect'
import PopupUtils from '@utils/popup-utils'
import { DialogOptions } from '@views/Popup/Dialog'
import { BETTING_HISTORY_TAB_KEY } from '@constants/index'
import { BettingRecordTrack } from '@store/bettingHistoryStore'
import MoneyInfo from '@views/ItemShop/MoneyInfo'
import ChatSettingPopup from '@views/Popup/Chat/ChatSettingPopup'
import GuestModePopup from '@views/Popup/GuestModePopup'
import Login from '@views/Login'
import ChangeMatchPopup from '@views/Popup/ChangeMatch'
import { GAME_TYPE } from '@game-type/game-market-types'
import { REWARD_COMPLETE_POPUP_TYPE, RewardCompletePopup } from '@views/Popup/Event/RewardComplete'
import { GotBlessItemNotUsableInfo } from '@views/Matchup/BetSlip/AdditionalDividendCard/GotBlessItemNotUsableInfo'
import LiveVisualNotice from '@views/Matchup/MatchUpDetail/LiveVisualNotice'
import Telegram from '@views/Popup/Telegram'
import TelegramImg from '@assets/images/icon/telegram/telegram-modal-guide-img.png'
import { Button } from '@styles/button.style'
import TelegramSetting from '@views/Popup/TelegramSetting'
import MessageLinkInput from '@components/MessageLinkInput'

interface MessageLinkAttachDialogOptions extends Omit<DialogOptions, 'custom'> {
  value?: string
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
}

export default class DialogUtils {

  static showUserPickNullOngoingBetInfo(): void {
    globalStore.pushDialogOk({
      custom: <UserPickNullOngoingBetInfo/>,
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
    })
  }

  static showUserPickIsOngoingBetInfo(props: { closeCallback: () => void }): void {
    globalStore.pushDialogOk({
      custom: <UserPickIsOngoingBetInfo/>,
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialog: props.closeCallback,
    })
  }


  static showImagePreview(props: { imageSrc: string, imageAlt?: string }): void {
    const { imageSrc, imageAlt = '업로드 이미지' } = props
    globalStore.pushDialogOk({
      custom: (
        <div css={UploadImgStyle}>
          <img src={imageSrc} alt={imageAlt}/>
        </div>
      ),
      className: 'image-full-popup',
      singlePress: '닫기',
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showPenaltyInfo(penaltyMessage: string): void {
    globalStore.pushDialogOk({
      custom: (
        <UserPenaltyInfo penaltyMessage={penaltyMessage}/>
      ),
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showChatPenaltyInfo(): void {
    globalStore.pushDialogOk({
      custom: (
        <ChatPenaltyInfo/>
      ),
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showUserPickEtcMarketFilterList(userPickEtcMarkets: Schema$UserPickMarket[], matchId: number): void {
    globalStore.pushDialogOk({
      title: '베팅타입 선택',
      custom: <EtcMarketFilterList markets={userPickEtcMarkets} matchId={matchId}/>,
      className: 'middle-size box-type',
      singlePress: '닫기',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showUserActivityRatingInfo(userActivity: Schema$UserActivitySummary): void {
    globalStore.pushDialogOk({
      title: '활동등급',
      custom: <RatingInfo userActivity={userActivity}/>,
      className: 'box-type big-size',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showMatchRecord(
    matchRecordSimpleMatchInfo: MatchRecordSimpleMatchInfo,
  ): void {
    globalStore.pushDialogOk({
      title: '',
      custom: (
        <MatchRecord
          matchRecordSimpleMatchInfo={matchRecordSimpleMatchInfo}
        />
      ),
      className: 'box-type big-size',
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  // static showUserDetailInfo(userPromiseId: string): void {
  //   globalStore.pushDialogOk({
  //     custom: <UserPickUserInfo userPromiseId={userPromiseId}/>,
  //     className: 'big-size box-type',
  //     singlePress: '닫기',
  //     callbackCloseDialog: () => {
  //       globalStore.closeDialog()
  //     },
  //     // 뒷배경 클릭 시 닫히도록
  //     callbackCloseDialogBg: () => {
  //       globalStore.closeDialog()
  //     },
  //   })
  // }

  static userPickCommentDelete(): void {
    globalStore.pushDialogYesNo({
      title: '답글 삭제',
      text: ['정말 삭제하시겠습니까?'],
      wrapClassName: 'box-type small-size',
      negativePress: '취소',
      positivePress: '삭제',
      callbackPositive: () => {
        showToast(TOAST_TYPE.INFO, '삭제되었습니다.')
      },
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showUserReport(params: {
    reportType: USER_REPORT_TYPE
    targetId: string
    targetUserPromiseId: string
    callbackReport?: (result) => void
  }): void {
    globalStore.pushDialogYesNo({
      title: '신고사유',
      custom: <AdvReportList/>,
      className: 'big-size checkbox',
      negativePress: '취소',
      positivePress: '신고',
      callbackPositiveFreeze: async () => {
        let result = false
        if (_.isEmpty(reportStore.selectedReportTextList)) {
          showToast(TOAST_TYPE.WARN, '신고사유를 선택해주세요.')
        } else {
          const reportResult = await reportStore.createReport(params)
          if (reportResult) {
            if (reportResult.alreadyExists) {
              showToast(TOAST_TYPE.INFO, '이미 신고한 글입니다.')
            } else {
              showToast(TOAST_TYPE.INFO, '신고되었습니다.')
            }
            result = true
          } else {
            showToast(TOAST_TYPE.ERROR, '신고에 실패 하였습니다.')
          }

          if (params.callbackReport) {
            params.callbackReport(result)
          }
          return result
        }
      },
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }
  static showUserBlock(
      userPromiseId: string,
      userNick: string,
      userProfileImg: string,
      successCallback?: (userPromiseId: string, blockTypes: COMMUNICATION_BLOCK_TYPE[]) => void
  ): void {
    globalStore.pushDialogYesNo({
      custom: (
        <AdvBlockList
          userPromiseId={userPromiseId}
          userNick={userNick}
          userProfileImg={userProfileImg}
        />
      ),
      // TODO 체크박스 전체 해제상태시 disabled 클래스 추가해주시면 됩니다.
      className: 'new-slide-type',
      negativePress: '취소',
      positivePress: '확인',
      callbackPositiveFreeze: async () => {
        if (_.isEmpty(componentStore.selectedUserCommunicationBlocks)) {
          showToast(TOAST_TYPE.INFO, '선택된 차단 목록이 없습니다.')
          return false
        }

        const result = await componentStore.setRegistrationCommunicationBlock(userPromiseId)

        if (!result) {
          showToast(TOAST_TYPE.INFO, '차단에 실패했습니다.')
          return false
        }

        if (!_.isNil(result.errcode)) {
          if (result.errcode === ERR.COMMUNICATION_BLOCK_FAIL_BLOCK_USER_LIMIT_EXCEED) {
            const blockLimitCount = globalStore.findGlobalSetting(
              GlobalStoreKey.COMMUNICATION_BLOCK_USER_LIMIT_COUNT,
            )?.value || 20

            showToast(TOAST_TYPE.ERROR, `${blockLimitCount} 명까지 차단할 수 있습니다.`)
          } else if (result.errcode === ERR.COMMUNICATION_BLOCK_FAIL_CI_VALUE_IS_MINE) {
            showToast(TOAST_TYPE.INFO, '동일명의 계정은 차단할수 없습니다.')
          } else {
            showToast(TOAST_TYPE.INFO, '차단에 실패했습니다.')
          }
          return false
        }

        const isChatBlock = _.includes(componentStore.selectedUserCommunicationBlocks,
          COMMUNICATION_BLOCK_TYPE.CHAT_AND_SPORT_TALK)
        if (isChatBlock) {
          chattingStore.addChatBlockUserId(userPromiseId)
        } else {
          chattingStore.removeChatBlockUserId(userPromiseId)
        }

        showToast(TOAST_TYPE.INFO, '차단되었습니다.')
        if (successCallback) {
          successCallback(userPromiseId, componentStore.selectedUserCommunicationBlocks)
        }
        return true
      },
      callbackCloseDialog: () => {
        componentStore.resetSelectedUserCommunicationBlocks()
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        componentStore.resetSelectedUserCommunicationBlocks()
        globalStore.closeDialog()
      },
    })
  }
  static showUserUnBlock(
    userPromiseId: string,
    successCallback?: (userPromiseId: string, blockTypes: COMMUNICATION_BLOCK_TYPE[]) => void
  ): void {
    globalStore.pushDialogYesNo({
      title: '차단해제',
      text: ['모든 차단을 해제하시겠습니까?'],
      className: 'middle-size',
      negativePress: '취소',
      positivePress: '해제',
      callbackPositiveFreeze: async () => {
        const result = await componentStore.unblockCommunicationBlockUser(userPromiseId)
        if (!result) {
          showToast(TOAST_TYPE.INFO, '차단 해제에 실패했습니다.')
          return false
        }

        componentStore.removeCommunicationBlockUserInfo(userPromiseId)
        chattingStore.removeChatBlockUserId(userPromiseId)
        showToast(TOAST_TYPE.INFO, '차단 해제되었습니다.')

        if (successCallback) {
          successCallback(userPromiseId, componentStore.selectedUserCommunicationBlocks)
        }
        return true
      },
      callbackCloseDialog: () => {
        componentStore.resetSelectedUserCommunicationBlocks()
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        componentStore.resetSelectedUserCommunicationBlocks()
        globalStore.closeDialog()
      },
    })
  }

  static userTitleSetting(): void {
    globalStore.pushDialogOk({
      title: '칭호설정',
      custom: <UserTitleSetting/>,
      className: 'box-type big-size',
      singlePress: '닫기',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showKakaoNewUserInfo(): void {

    globalStore.pushDialogOk({
      custom: <UnableToJoinInfo/>,
      wrapClassName: 'ant-popover kakao-login',
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showTransferApplicationCompletedInfo(
    confirmCallback: () => void
  ): void {
    globalStore.pushDialogOk({
      custom: <TransferApplicationCompletedInfo/>,
      wrapClassName: 'ant-popover kakao-login',
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
        if (confirmCallback) {
          confirmCallback()
        }
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showApplyForAccountTransferInfo(
    accountInfo: TransferableAccount,
    successCallback: () => void,
    processCompleteCallback: () => void,
  ): void {
    const targetUserPromiseId = accountInfo?.userPromiseId
    globalStore.pushDialogYesNo({
      title: '계정 이관 신청을 하시겠습니까?',
      custom: <ApplyForAccountTransferInfo
        accountInfo={accountInfo}
      />,
      wrapClassName: 'ant-popover kakao-login',
      className: 'big-size',
      negativePress: '취소',
      positivePress: '확인',
      callbackPositiveFreeze: async (): Promise<boolean> => {
        const { isComplete, errcode } = await userStore.registerAccountTransfer(targetUserPromiseId)

        if (_.isNil(errcode) && isComplete) {
          if (processCompleteCallback) {
            processCompleteCallback()
          }

          setTimeout(() => {
            this.showTransferApplicationCompletedInfo(successCallback)
          })
          return true
        }

        Utils.showToast(TOAST_TYPE.ERROR, '다시 진행해주시기 바랍니다.')
        return false
      },
      callbackCloseDialog: () => {
        if (processCompleteCallback) {
          processCompleteCallback()
        }
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        if (processCompleteCallback) {
          processCompleteCallback()
        }
        globalStore.closeDialog()
      },
    })
  }

  static showKakaoServiceTerminationInfo(): void {
    globalStore.pushDialogOk({
      custom: <KakaoServiceTerminationInfo/>,
      wrapClassName: 'ant-popover kakao-login',
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showNewAccountApplicationCompleteKakao(callbackClose: () => void): void {
    globalStore.pushDialogOk({
      custom: <ApplyForNewAccount/>,
      wrapClassName: 'ant-popover kakao-login',
      className: 'box-type big-size character-popup',
      singlePress: '카카오 로그인하기',
      callbackCloseDialog: () => {
        authStore.logout(LogoutType.USER, false).catch(console.error)
        window.Kakao.Auth.login({
          success(result) {
            window.Kakao.Auth.setAccessToken(result.access_token)
            window.Kakao.API.request({
              url: '/v2/user/me',
              success(user) {
                const params = {
                  username: user.id,
                  password: 'null',
                  email: user.kakao_account.email,
                }
                StorageUtils.saveSignType(ACCOUNT_TYPE.KAKAO)
                StorageUtils.removeUserId()
                authStore.loginByKakao(params).catch(console.error)

                if (callbackClose) {
                  callbackClose()
                }
              },
              fail(err) {
                console.log('kakao user info fail', err)
                if (callbackClose) {
                  callbackClose()
                }
              },
            })
          },
          fail(err) {
            console.log('kakao auth fail.')
            if (callbackClose) {
              callbackClose()
            }
          },
        })


      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
        if (callbackClose) {
          callbackClose()
        }
      },
    })
  }

  static showDeleteSportTalk(callbackPositive: () => void): void {
    globalStore.pushDialogYesNo({
      title: '스포츠톡 삭제',
      text: ['삭제 후 복원이 불가능합니다.', '삭제하시겠습니까?'],
      className: 'middle-size',
      negativePress: '취소',
      positivePress: '삭제',
      callbackPositive,
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showCardCountGuide(): void {
    globalStore.pushDialogOk({
      custom: <SoccerCardCountGuide/>,
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showRegisterAllFavorites(callbackPositive: () => void): void {
    globalStore.pushDialogYesNo({
      title: '전체 관심등록',
      text: ['모든 유저를 관심 등록하시겠습니까?'],
      className: 'middle-size',
      negativePress: '취소',
      positivePress: '등록',
      callbackPositive,
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }
  static showUnregisterAllFavorites(callbackPositive: () => void): void {
    globalStore.pushDialogYesNo({
      title: '전체 관심해제',
      text: ['모든 유저를 관심 해제하시겠습니까?'],
      className: 'middle-size',
      negativePress: '취소',
      positivePress: '해제',
      callbackPositive,
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showBettingHistoryAllDelete(callbackPositive: () => void): void {
    globalStore.pushDialogYesNo({
      title: '전체 삭제',
      text: ['삭제 후 복원이 불가능합니다.', '삭제하시겠습니까?'],
      className: 'middle-size',
      negativePress: '취소',
      positivePress: '삭제',
      callbackPositive,
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showSharedBettingList(
    { betId, bettingRecordTrack, fromUserNick }:
    { betId?: string, bettingRecordTrack?: BettingRecordTrack, fromUserNick: string }
  ): void {
    const popupTit = (
      <Fragment>
        <span className="am-modal-title--point--blue">{fromUserNick}</span>님의 공유 내역
      </Fragment>
    )
    globalStore.pushDialogOk({
      iconTitle: popupTit,
      custom: <SharedBettingListPopup bettorBetId={betId} bettingRecordTrack={bettingRecordTrack}/>,
      className: 'big-size box-type icon-tit share-betting-popup',
      singlePress: '확인',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showUnableToChangeNickname(): void {
    globalStore.pushDialogYesNo({
      title: '닉네임 변경 불가',
      text: ['닉네임 변경권이 부족합니다.', '아이템샵으로 이동하시겠습니까?'],
      className: 'small-size',
      positivePress: '아이템 구매',
      negativePress: '취소',
      callbackPositive: () => {
        if (isMobile) {
          loadOrReload('/itemshop')
        } else {
          PopupUtils.showItemShopPopup()
        }
      },
    })
  }

  static showMessageLinkAttachDialog(params: MessageLinkAttachDialogOptions): void {
    const { value, onChange, ...dialogOptions } = params
    globalStore.pushDialogOk({
      ...dialogOptions,
      custom: <MessageLinkInput value={value} onChange={onChange}/>,
      className: 'middle-size',
      singlePress: '확인',
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showDeleteMessage(params?: DialogOptions): void {
    globalStore.pushDialogYesNo({
      ...params,
      text: ['삭제 후 복원이 불가능합니다.', '삭제하시겠습니까?'],
      negativePress: '취소',
      positivePress: '삭제',
    })
  }

  static showDeleteAllMessage(params?: DialogOptions): void {
    globalStore.pushDialogYesNo({
      ...params,
      text: ['삭제 후 복원이 불가능합니다.', '삭제하시겠습니까?'],
      negativePress: '취소',
      positivePress: '삭제',
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showSaveBettingHistoryComplete(
    { fromViewType, onClose }:
    { fromViewType: FROM_VIEW_TYPE, onClose?: () => void }
  ): void {
    globalStore.pushDialogYesNo({
      title: '저장 완료',
      text: ['저장 내역과 동일한 경기에', '베팅이 가능합니다.', '이동하시겠습니까?'],
      className: 'small-size',
      negativePress: '취소',
      positivePress: '이동',
      callbackPositive: () => {
        if (onClose) { onClose() }
        globalStore.closeGeneralPopup()
        globalStore.setBettingHistoryTabInitialTabKey(BETTING_HISTORY_TAB_KEY.SHARED)
        bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.MESSAGE)
        bettingHistoryStore.setBettingHistoryInitProps({ onlyMajorClub: false, fromViewType })
        if (isMobile) {
          loadOrReload('/betting-history')
        } else {
          PopupUtils.showBettingHistoryPopup()
        }
      },
    })
  }

  static showMoneyInfo(): void {
    globalStore.pushDialogOk({
      title: '재화',
      custom: <MoneyInfo/>,
      className: 'big-size box-type',
      singlePress: '닫기',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showUnableToCreateClub(): void {
    globalStore.pushDialogOk({
      text: ['클럽 개설은 PC버전에서만 가능합니다.', '1. https://home.adventurer.co.kr', '2. 자료실에서 게임 다운로드', '3. 로그인 후 GAME START 버튼 클릭', '4. 게임 접속 후 마이룸으로 이동 후', '클럽 개설'],
      className: 'align-left-dialog small-size',
    })
  }

  static showClubCreationMembershipRequired(): void {
    globalStore.pushDialogOk({
      title: '알림',
      text: ['프리 라이선스는 승부사온라인 멤버십', '계정만 구매할 수 있습니다.', ' ', '멤버십 계정 무료 생성', 'https://home.adventurer.co.kr'],
      className: 'small-size',
    })
  }

  static showDeleteComment(params?: DialogOptions): void {
    globalStore.pushDialogYesNo({
      ...params,
      text: ['삭제 후 복원이 불가능합니다.', '삭제하시겠습니까?'],
      wrapClassName: 'z-index-10001',
      negativePress: '취소',
      positivePress: '삭제',
    })
  }

  static showChatSetting(): void {
    globalStore.pushDialogOk({
      title: '채팅 설정',
      custom: <ChatSettingPopup/>,
      className: 'box-type big-size',
      singlePress: '닫기',
      callbackPositive: () => {
        // 일단 속도 문제 때문에 채팅창을 닫고 열기로 했으나
        // 테스트를 해보고 문제가 되면 채팅창을 닫도록 하고 그전까지는 유지
        // onClickToggleChat()
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showDeleteMatchFromChat(params?: DialogOptions): void {
    globalStore.pushDialogYesNo({
      ...params,
      title: '라이브 스코어 제거',
      text: ['제거한 경기는 다시 추가할 수 없습니다.', '정말 제거하시겠습니까?'],
      className: 'middle-size',
      negativePress: '취소',
      positivePress: '확인',
    })
  }

  static showMatchTimeLineFromChat(params?: DialogOptions): void {
    globalStore.pushDialogOk({
      ...params,
      title: '',
      wrapClassName: 'chatting-live-score-timeline',
      className: 'box-type big-size live-score-timeline',
    })
  }

  static showChangeNickConfirm(params?: DialogOptions): void {
    globalStore.pushDialogYesNo({
      ...params,
      title: '닉네임 변경',
      text: ['닉네임 변경권이 1개 소진됩니다.', '변경하시겠습니까?'],
      className: 'small-size',
      positivePress: '변경',
      negativePress: '취소',
    })
  }

  static showSportIssueContent(params?: DialogOptions): void {
    globalStore.pushDialogOk({
      ...params,
      className: 'image-full-popup swiper-popup',
      singlePress: '닫기',
    })
  }

  static showCancelBet(params?: DialogOptions): void {
    globalStore.pushDialogYesNo({
      ...params,
      title: '알림',
      className: 'small-size',
      positivePress: '확인',
      negativePress: '취소',
    })
  }

  static showGuestMode(): void {
    globalStore.pushDialogOk({
      custom: <GuestModePopup/>,
      className: 'small-size event',
      callbackCloseDialog: () => {
        if (isMobile) {
          globalStore.setVisibleSideBar(true)
        } else {
          authStore.showLoginPopup(<Login/>)
        }
      },
    })
  }

  static showInsufficientSCash(params?: DialogOptions): void {
    globalStore.pushDialogYesNo({
      ...params,
      id: 'sCashNotEnough',
      title: 'S캐시 충전',
      text: ['S캐시가 부족합니다.', '충전하시겠습니까?'],
      className: 'small-size',
      positivePress: 'S캐시 충전',
      negativePress: '취소',
    })
  }

  static showClosedMatchUpAlert(intervalObj?: string | number | NodeJS.Timeout): void {
    globalStore.pushDialogOk({
      id: 'matchup_detail_close_alert',
      title: '알림',
      text: ['베팅이 종료된 경기 입니다.'],
      className: 'small-size',
      callbackCloseDialog: () => {
        if (!isMobile) {
          if (intervalObj) {
            clearInterval(intervalObj)
          }

          matchupStore.clearDetailTrack()
          return
        }

        globalStore.setVisibleMatchupDetailPopup(false)
        globalStore.closeGeneralPopup()
      },
    })
  }

  static showChangeMatch(
    { currentGameKey, imageSrc, tournamentName }:
    { currentGameKey: GAME_TYPE, imageSrc: string, tournamentName: string }
  ): void {
    let changeMatchTit
    if (currentGameKey === GAME_TYPE.CROSS) {
      changeMatchTit = (
        <Fragment>
          <span className="am-modal-title--img">
            <img src={imageSrc} alt="리그 엠블럼" className="league-ico"/>
          </span>
          <span className="am-modal-title--txt">
            {tournamentName}
          </span>
        </Fragment>
      )
    } else if (currentGameKey === GAME_TYPE.LIVE) {
      changeMatchTit = '진행중인 라이브 경기'
    }
    globalStore.pushDialogOk({
      iconTitle: changeMatchTit,
      custom: <ChangeMatchPopup
        gameType={currentGameKey}
      />,
      className: 'big-size icon-tit box-type',
      wrapClassName: 'change-match',
      singlePress: '닫기',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showClubNotJoinedBettingDisabled(params?: DialogOptions): void {
    globalStore.pushDialogYesNo({
      ...params,
      text: ['클럽 미가입 상태에서는', '베팅할 수 없습니다.', '무료 가입하시겠습니까?'],
      className: 'small-size',
      positivePress: '클럽무료가입',
      negativePress: '취소',
    })
  }

  static showClubNotJoined(params?: DialogOptions): void {
    globalStore.pushDialogYesNo({
      ...params,
      text: ['클럽 미가입 상태입니다.', '가입하시겠습니까?'],
      className: 'small-size',
      positivePress: '클럽무료가입',
      negativePress: '취소',
    })
  }

  static showRewardCompletePopup(
    rewardItem,
    rewardPopupType: REWARD_COMPLETE_POPUP_TYPE,
    params?: DialogOptions
  ): void {
    globalStore.pushDialogOk({
      ...params,
      custom: <RewardCompletePopup popupType={rewardPopupType}
                                   item={rewardItem}/>,
      className: 'middle-size box-type',
      positivePress: '확인',
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showIncompatibleMarketType(): void {
    globalStore.pushDialogOk({
      title: '알림',
      text: ['메인 마켓타입과 조합할 수 없습니다.'],
      singlePress: '닫기',
      className: 'small-size',
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showUnavailableGotBlessItemFoldCondition():void {
    globalStore.pushDialogOk({
      custom: <GotBlessItemNotUsableInfo/>,
      className: 'box-type big-size character-popup',
    })
  }

  static showLiveDetailNoticePopup(): void {
    globalStore.pushDialogOk({
      title: '유의사항',
      custom: <LiveVisualNotice/>,
      className: 'big-size box-type',
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showUnableToJoinClub(): void {
    globalStore.pushDialogOk({
      title: '가입불가',
      text: ['이용할 수 없는 사용자입니다.', '이메일 문의(help@adventurer.co.kr)를 통해 문의해 주시기 바랍니다.'],
      singlePress: '닫기',
      className: 'small-size',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showWithdrawalRejoinWait(params?: DialogOptions): void {
    globalStore.pushDialogOk({
      ...params,
      singlePress: '닫기',
      className: 'box-type big-size character-popup',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showVerificationFailed(): void {
    globalStore.pushDialogOk({
      title: '본인인증 실패',
      text: ['회원 가입 시 명의 정보와 일치하지 않습니다.'],
      singlePress: '닫기',
      className: 'small-size',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showMinRateValidate(): void {
    globalStore.pushDialogOk({ title: '알림', text: ['1.01이상 배당만 베팅이 가능합니다.'], className: 'small-size' })
  }

  static showTelegramSetting(): void {
    const goGuide = () => {
      PopupUtils.showTelegramGuidePopup({
        wrapClassName: '',
        className: '',
        isScroll: true,
        custom: false,
        clsBtn: false,
      })
    }
    const TelegramBanner = () => (
      <Button onClick={goGuide}>
        <img src={TelegramImg} alt="이제 적중알림을 텔레그램으로 편하게 받자. 자세히 보기"/>
      </Button>
    )

    globalStore.pushDialogOk({
      custom: <Telegram/>,
      className: 'big-size box-type',
      title: '알림 설정',
      singlePress: '확인',
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
      topBanner: <TelegramBanner/>
    })
  }

  /**
   * 텔레그램 연동완료 팝업.
   *
   * 이미지는 어드민(회원 > 텔레그램 관리 > 연동완료 팝업 이미지 관리)에서 등록한 것을 쓴다.
   * 미등록이면 서버가 null 을 내려주며, 이때는 이미지 없이 `확인` 버튼만 있는 팝업이 뜬다
   * — 깨진 이미지를 노출하지 않기 위함이다.
   */
  static showCompletedTelegramSetting = (popupImageUrl?: string) => (
    globalStore.pushDialogOk({
      custom: <TelegramSetting popupImageUrl={popupImageUrl}/>,
      className: 'big-size box-type',
      singlePress: '확인',
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  )
}
